import { type ApolloError, gql, useQuery } from '@apollo/client';
import { FeatureEnum, type Region } from '@/types/GraphqlSchema';

const QUERY = gql`
  query regions($feature: FeatureEnum) {
    regions(feature: $feature) {
      id
      displayName
    }
  }
`;

type UseGetRegionsParams = {
  feature: FeatureEnum;
};

type UseGetRegionsReturn = {
  regions: Region[];
  loading: boolean;
  error: ApolloError | undefined;
};

export const useGetRegions = (
  { feature }: UseGetRegionsParams = { feature: FeatureEnum.WebPlatform },
): UseGetRegionsReturn => {
  const { data, loading, error } = useQuery(QUERY, { variables: { feature } });

  return {
    regions: data?.regions || [],
    loading,
    error,
  };
};
